import React, { useState, useEffect } from 'react';
import CountriesService from '../../../services/countriesService';

const AddressForm = ({ initialAddress, onAddressChange }) => {
  const [address, setAddress] = useState(initialAddress || { line1: '', line2: '', suburb: '', country: '', state: '', postcode: '' });
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [loadingCountries, setLoadingCountries] = useState(true);

  // Load countries from database
  useEffect(() => {
    const loadCountries = async () => {
      try {
        const countryList = await CountriesService.getCountriesForDropdowns();
        setCountries(countryList);
      } catch (error) {
        console.error('Error loading countries:', error);
        // Fallback to empty array
        setCountries([]);
      } finally {
        setLoadingCountries(false);
      }
    };
    loadCountries();
  }, []);

  useEffect(() => {
    // States are not currently managed in the database, so we keep empty for now
    // This can be extended later if needed
    setStates([]);
  }, [address.country]);

  const handleChange = (field, value) => {
    const newAddress = { ...address, [field]: value };
    if (field === 'country') {
      newAddress.state = '';
    }
    setAddress(newAddress);
    onAddressChange(newAddress);
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Street number and name</label>
        <input type="text" value={address.line1} onChange={(e) => handleChange('line1', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md" required />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Line 2 (optional)</label>
        <input type="text" value={address.line2} onChange={(e) => handleChange('line2', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Suburb or City</label>
        <input type="text" value={address.suburb} onChange={(e) => handleChange('suburb', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md" required />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Country</label>
        <select 
          value={address.country} 
          onChange={(e) => handleChange('country', e.target.value)} 
          className="w-full px-3 py-2 border border-gray-300 rounded-md" 
          required
          disabled={loadingCountries}
        >
          <option value="">Select Country</option>
          {countries.map(country => (
            <option key={country.code} value={country.name}>{country.name}</option>
          ))}
        </select>
        {loadingCountries && (
          <p className="text-xs text-gray-500 mt-1">Loading countries...</p>
        )}
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">State or Province</label>
        <select value={address.state} onChange={(e) => handleChange('state', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md" required disabled={!states.length}>
          <option value="">Select State/Province</option>
          {states.map(state => <option key={state} value={state}>{state}</option>)}
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Postcode or Zip</label>
        <input type="text" value={address.postcode} onChange={(e) => handleChange('postcode', e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md" required />
      </div>
    </div>
  );
};

export default AddressForm;
